import { ResourceTypeEnum } from '@/shared/components/ui/resource-icon/resource-icon.types';
import { useRbacConfig } from '@/shared/features/rbac/context/rbac-config-context';

export const useDefaultResourceType = (): ResourceTypeEnum => {
  const { policies } = useRbacConfig();
  const resourceTypes = Object.keys(policies);

  if (resourceTypes.includes(ResourceTypeEnum.Device)) {
    return ResourceTypeEnum.Device;
  }

  return resourceTypes[0] as ResourceTypeEnum;
};
